<app-header title="self-serve.payYourTeam.addYourCraAccountInformation"></app-header>
<p class="text-color-secondary-font margin-bottom-6">{{ 'self-serve.payYourTeam.craDetails' | translate }}</p>

<form
    #form="ngForm"
    [appFormPersistence]="!stepStatus && !isLoading ? 'craForm' : ''"
    [class.loading]="isLoading"
    (ngSubmit)="onSubmit()"
>
    <div class="responsive-grid">
        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.legalCompanyName' | translate }}</mat-label>
            <input
                required
                matInput
                type="text"
                name="legalCompanyName"
                #legalCompanyName="ngModel"
                [(ngModel)]="company.name"
            />
            <mat-error *ngIf="legalCompanyName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
        </mat-form-field>
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.craBusinessNumber' | translate }}</mat-label>
                <input
                    required
                    pattern="[178]\d{8}"
                    matInput
                    type="text"
                    name="craBusinessNumber"
                    #craBusinessNumber="ngModel"
                    [(ngModel)]="company.craBusinessNumber"
                />

                <mat-hint>{{ 'self-serve.payYourTeam.craBusinessNumberHint' | translate }}</mat-hint>
                <mat-error *ngIf="craBusinessNumber.invalid">{{
                    'self-serve.payYourTeam.craBusinessNumberInvalid' | translate
                }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.craProgramCode' | translate }}</mat-label>
                <!-- input is disabled because RP is the default -->
                <input
                    required
                    disabled
                    pattern="(RP|NW)"
                    matInput
                    type="text"
                    name="craProgramCode"
                    #craProgramCode="ngModel"
                    [(ngModel)]="company.craProgramCode"
                />
                <!-- <mat-hint>{{ 'self-serve.payYourTeam.craProgramCodeHint'| translate}}</mat-hint> -->
                <mat-error *ngIf="craProgramCode.invalid">{{
                    'self-serve.payYourTeam.craProgramCodeInvalid' | translate
                }}</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.craReferenceNumber' | translate }}</mat-label>
                <input
                    required
                    pattern="\d{4}"
                    matInput
                    type="text"
                    name="craReferenceNumber"
                    #craReferenceNumber="ngModel"
                    [(ngModel)]="company.craReferenceNumber"
                />
                <mat-hint>{{ 'self-serve.payYourTeam.craReferenceNumberHint' | translate }}</mat-hint>
                <mat-error *ngIf="craReferenceNumber.invalid">{{
                    'self-serve.payYourTeam.craReferenceNumberInvalid' | translate
                }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'payroll.setup.remitterType' | translate }}</mat-label>
                <mat-select
                    matInput
                    name="remitterType"
                    #remitterType="ngModel"
                    [(ngModel)]="company.remitterType"
                    required
                >
                    <mat-option value="quarterly">{{ 'payroll.setup.quarterly' | translate }}</mat-option>
                    <mat-option value="monthly">{{ 'payroll.setup.monthly' | translate }}</mat-option>
                    <mat-option value="threshold_1">{{ 'payroll.setup.threshold1Accelerated' | translate }}</mat-option>
                    <mat-option value="threshold_2">{{ 'payroll.setup.threshold2Accelerated' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="flex buttons justify-end">
        <ui-button *ngIf="showIWillDoItLater" type="outline" (click)="next()">{{
            'self-serve.iWillDoItLater' | translate
        }}</ui-button>
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>
